module.exports = __webpack_public_path__ + "img/pic_russia_08.68cc8ca5.jpg";